import { render, staticRenderFns } from "./ExploreGlossary.vue?vue&type=template&id=b48cbd9c&scoped=true"
import script from "./ExploreGlossary.vue?vue&type=script&lang=js"
export * from "./ExploreGlossary.vue?vue&type=script&lang=js"
import style0 from "./ExploreGlossary.vue?vue&type=style&index=0&id=b48cbd9c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48cbd9c",
  null
  
)

export default component.exports